$(document).ready(function(){
   
$('img[srcset*="//dcaper.com/cdn/shop/files/IMG_3487_Squared.jpg"]').attr('alt', 'Hand holding white pill bottle with blue cap and Rx label, opening with dcaper tool');

$('img[srcset*="//dcaper.com/cdn/shop/files/IMG_3500_Squared.jpg"]').attr('alt', 'Hand opening prescription bottle with dcaper tool');

$('img[srcset*="//dcaper.com/cdn/shop/files/IMG_3594.jpg"]').attr('alt', 'Hand holding bottle and metal tool');

$('img[srcset*="//dcaper.com/cdn/shop/files/IMG_3600_Square_Text.jpg"]').attr('alt', 'Dcaper tool opener with 10,000 uses, new and used side-by-side');

$('img[srcset*="//dcaper.com/cdn/shop/files/IMG_3597.jpg"]').attr('alt', 'Dcaper metal tool with curved handle and hook front side');

$('img[srcset*="//dcaper.com/cdn/shop/files/IMG_3598.jpg"]').attr('alt', 'Hand holding supplement bottle on wooden cutting board');

$('img[srcset*="//dcaper.com/cdn/shop/files/IMG_3602.jpg"]').attr('alt', 'Dcaper tool');

$('img[srcset*="//dcaper.com/cdn/shop/files/IMG_3604.jpg"]').attr('alt', 'We take professional orders for dcaper tool');

$('img[srcset*="//dcaper.com/cdn/shop/files/IMG_2677-removebg_55362a36-eef8-4af4-b86c-b4b6e79db52b.png"]').attr('alt', 'Metal dcaper cocktail pick with hook');

$('img[srcset*="//dcaper.com/cdn/shop/files/IMG_3603.jpg"]').attr('alt', 'Dcaper tool set of 3');

$('img[srcset*="//dcaper.com/cdn/shop/files/IMG_3586_Cropped.jpg"]').attr('alt', 'Colorful plastic bottle caps on gray background');

$('img[srcset*="//dcaper.com/cdn/shop/files/IMG_3487_Squared.jpg"]').attr('alt', 'Hand holding white pill bottle with blue cap and Rx label, opening with dcaper tool');

$('img[srcset*="//dcaper.com/cdn/shop/files/IMG_3500_Squared.jpg"]').attr('alt', 'Hand opening prescription bottle with dcaper tool');

$('img[srcset*="//dcaper.com/cdn/shop/files/IMG_3511_Squared.jpg"]').attr('alt', 'Hand holding white Rx bottle with clear cap removed');

$('img[srcset*="//dcaper.com/cdn/shop/files/IMG_3608_16_9.jpg"]').attr('alt', 'Laptop and prescription bottles on a table');

  $("img[srcset*='//dcaper.com/cdn/shop/files/IMG_3606_16_9.jpg']").attr("alt", "Pill bottle, cap, and pill crusher on gray background");


setTimeout(() => {
  $('label[for="country-filter-input"]').removeAttr('for'); 
  $('a[href="/"]').attr('aria-label','Go to homepage'); 
  $('img[src*="Dcaper_v6_2_downscaled"]').attr('alt','Dcaper logo');
   $('img[src*="b6ee3df0a2e14a4d8d18e7454bd09ccb"]').attr('alt','Product preview');
  /*
  $("img[src=\"//dcaper.com/cdn/shop/files/IMG_3594.jpg?v=1778531226&amp;width=3840\"]").attr("alt", "Hand holding bottle and Dcaper tool");
    $("img[src=\"//dcaper.com/cdn/shop/files/IMG_3600_Square_Text.jpg?v=1778571051&amp;width=3840\"]").attr("alt", "Dcaper tool opener with 10,000 uses, new and used side-by-side");
    $("img[src=\"//dcaper.com/cdn/shop/files/IMG_3597.jpg?v=1778531226&amp;width=3840\"]").attr("alt", "Dcaper Metal tool with curved handle and angled end");
    $("img[src=\"//dcaper.com/cdn/shop/files/IMG_3598.jpg?v=1778531226&amp;width=3840\"]").attr("alt", "Hand holding supplement bottle on wooden cutting board");
    $("img[src=\"//dcaper.com/cdn/shop/files/IMG_3602.jpg?v=1778571481&amp;width=3840\"]").attr("alt", "Dcaper opener tool");
    $("img[src=\"//dcaper.com/cdn/shop/files/IMG_3604.jpg?v=1778571481&amp;width=3840\"]").attr("alt", "Metal fan-shaped object with oval cutouts");

  
    $("img[src=\"//dcaper.com/cdn/shop/files/IMG_2677-removebg_55362a36-eef8-4af4-b86c-b4b6e79db52b.png?v=1778520977&amp;width=800\"]").attr("alt", "Metal dcaper cocktail pick with hook");


    $("img[src=\"//dcaper.com/cdn/shop/files/IMG_3602.jpg?v=1778571481&width=3840\"]").attr("alt", "Dcaper tool");
    $("img[src=\"//dcaper.com/cdn/shop/files/IMG_3603.jpg?v=1778571482&width=3840\"]").attr("alt", "Dcaper tool set of 3");
    $("img[src=\"//dcaper.com/cdn/shop/files/IMG_3604.jpg?v=1778571481&width=3840\"]").attr("alt", "We take professional orders for dcaper tool");

      $("img[src=\"//dcaper.com/cdn/shop/files/IMG_3594.jpg?v=1778531226&width=3840\"]").attr("alt", "Hand holding bottle and metal tool");
   
    $("img[src=\"//dcaper.com/cdn/shop/files/IMG_3597.jpg?v=1778531226&width=3840\"]").attr("alt", "Dcaper Metal tool with curved handle and hook front side");
    $("img[src=\"//dcaper.com/cdn/shop/files/IMG_3598.jpg?v=1778531226&width=3840\"]").attr("alt", "Hand holding supplement bottle on wooden cutting board");
   $("img[src=\"//dcaper.com/cdn/shop/files/IMG_3586_Cropped.jpg?v=1778528414&amp;width=3840\"]").attr("alt", "Colorful plastic bottle caps on gray background");
*/
   }, 1000);

let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;

 $("img[src=\"//dcaper.com/cdn/shop/files/IMG_3487_Squared.jpg?v=1778524910&amp;width=3840\"]").attr("alt", "Hand holding white pill bottle with blue cap and Rx label, opening with dcaper tool");
    $("img[src=\"//dcaper.com/cdn/shop/files/IMG_3500_Squared.jpg?v=1778524911&amp;width=3840\"]").attr("alt", "Hand opening prescription bottle with dcaper tool");
    $("img[src=\"//dcaper.com/cdn/shop/files/IMG_3511_Squared.jpg?v=1778524910&amp;width=3840\"]").attr("alt", "Hand holding white Rx bottle with clear cap removed");
     $("img[src=\"//dcaper.com/cdn/shop/files/IMG_3608_16_9.jpg?v=1778572861&amp;width=3840\"]").attr("alt", "Laptop and prescription bottles on a table");
   
    if ( $('#goog-gt-votingInputSrcLang').length) {

$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
    
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 20) {
        clearInterval(Intervaltime_google);
       
    }
}

//$('input[name="country_filter"]').attr('aria-label','Filter by country');

console.log("ready");
});
